namespace Roodik.Game
{
	import ViewBase = Roodik.Core.ViewBase;

	export class LazyGameAssetsLoaderView extends ViewBase
	{
		constructor()
		{
			super("LazyAssetsPanelView");
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/View/LazyGameAssetsLoaderView.ts